"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryList = queryList;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 品牌列表
function queryList(query) {
  return (0, _requestPIM.default)({
    url: '/xyBrand/page',
    method: 'get',
    params: query
  });
}